import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    standalone: false
})
export class PageHeaderComponent implements OnInit {
  @Input()
  public title: string;

  constructor() {}

  ngOnInit(): void {}
}
